<template>
  <div class="orders">
    <div v-if="$store.state.isMobile">
      <tabs></tabs>
      <personalCard type="line" v-for="item in orders" :key="item.id" v-show="orders.length">
        <div slot="left" class="leftName">{{$store.state.ticketDetail.ticketName}}</div>
        <div slot="right" class="rightContent">
          <div class="detail">
            <span class="title">预约时间</span>
            <span class="name">{{item.bookingDate}}（{{item.timeRange}}）</span>
          </div>
          <div class="detail">
            <span class="title">参观人数</span>
            <span class="name">{{item.peopleCount}}人</span>
          </div>
          <div class="buttonsWarp">
            <div class="buttonCancel" @click="showOrderDetail('cancel', item.id)" v-if="activeTabIndex == 0">取消</div>
            <div class="buttonConfirm" @click="showOrderDetail('look', item.id, item.orderStatus)">查看</div>
          </div>
          <div v-if="item.orderType == 1" class="tuan"></div>
        </div>
      </personalCard>
      <div class="noData" v-if="!orders.length">暂无数据</div>
    </div>
    <div v-else>
      <topBanner></topBanner>
      <div class="pcContent">
        <pcTabs2 :reservationType="$route.query.rType || 1"></pcTabs2>
        <div class="pcItemCard">
          <pcTabs></pcTabs>
          <div class="personals">
            <personalCard type="line" v-for="item in orders" :key="item.id" v-show="orders.length">
              <div slot="left" class="leftName">{{$store.state.ticketDetail.ticketName}}</div>
              <div slot="right" class="rightContent">
                <div class="detail">
                  <span class="title">预约时间</span>
                  <span class="name">{{item.bookingDate}}（{{item.timeRange}}）</span>
                </div>
                <div class="detail">
                  <span class="title">参观人数</span>
                  <span class="name">{{item.peopleCount}}人</span>
                </div>
                <div class="buttonsWarp">
                  <div class="buttonCancel" @click="showOrderDetail('cancel', item.id)" v-if="activeTabIndex == 0">取消</div>
                  <div class="buttonConfirm" @click="showOrderDetail('look', item.id, item.orderStatus)">查看</div>
                </div>
                <div v-if="item.orderType == 1" class="tuan"></div>
              </div>
            </personalCard>
            <div class="noData" v-if="!orders.length">暂无数据</div>
          </div>
        </div>
      </div>
    </div>
    <div :class="$store.state.isMobile ? '' : 'pcContent'"  v-if="showPop">
      <pop>
        <slot>
          <div class="confirmText">您确定要删除吗？</div>
          <div class="buttonsWarp">
            <div class="buttonCancel" @click="cancel">取消</div>
            <div class="buttonConfirm" @click="confirm">确定</div>
          </div>
        </slot>
      </pop>
    </div>
  </div>
</template>

<script>
import tabs from '../../components/common/tabs.vue'
import pcTabs from '../../components/common/pcTabs.vue'
import personalCard from '../../components/common/personalCard.vue'
import topBanner from '../../components/common/topBanner'
import pcTabs2 from '../../components/ticket/pcTabs'
import pop from '../../components/common/pop'
export default {
  data() {
    return {
      orders: [],
      activeTabIndex: 0,
      showPop: false
    };
  },

  components: {tabs, personalCard, pcTabs, topBanner, pcTabs2, pop},

  methods: {
    activeTab(index) {
      this.activeTabIndex = index
      this.getOrders(index + 1)
    },

    cancel() {
      this.showPop = false
    },

    confirm() {
      this.showPop = false
    },

    showOrderDetail(type, id, status) {
      let query = this.$route.query
      query.orderId = id
      if (type == 'look' && status == 1) return this.$router.push({path: '/ticket/re_success', query})
      query.type = type
      this.$route.query.id ? query.id = this.$route.query.id : ''
      this.$router.push({path: '/ticket/orderDetail', query})
    },

    delOrder(item) {
      this.showPop = true
    },

    getOrders(status) {
      this.$ajax(`/api/ticket/front/order?museumCode=${this.$route.query.museumCode}&orderStatus=${status || ''}${this.$route.query.id ? `&ticketId=${this.$route.query.id}` : ''}`).then((res) => {
        this.orders = res.data.map((item) => {
          item.bookingDate = item.bookingDate.replaceAll('-', '/')
          item.timeRange = item.timeRange.replace(':00-', '-').substring(0,11)
          return item
        })
      })
    }
  },

  created() {
    this.getOrders(1)
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.orders{
  .detail{
    .title{
      margin-right: 0.3rem;
    }
  }
  .confirmText{
    margin: 0.5rem 0;
    font-size: 0.6rem;
    font-weight: 500;
  }
  .buttonsWarp{
    div{
      width: 2.5rem;
    }
  }
  .pcItemCard{
    margin-top: 40px;
    .personals{
      display: flex;
    }
  }
  .noData{
    margin-top: 1rem;
    text-align: center;
    width: 100vw;
    font-size: 0.5rem;
  }
  .pcContent{
    .noData{
      font-size: 30px;
    }
  }
}
</style>
<style type="text/css" lang="scss">
  .orders{
    .pcItemCard{
      .personalCard{
        margin: 30px 0;
        .leftLine{
          padding: 0;
          width: 76px;
          min-height: 150px;
          max-height: 300px;
          max-width: 100px;
          margin: 20px 0;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .leftName{
          font-size: 20px !important;
          max-width: unset !important;
          height: auto !important;
          line-height: 26px !important;
        }
        .right{
          width: 370px;
          margin-left: 0;
        }
      }
      .personalCard:nth-child(2n-1){
        margin-right: 4%;
      }
    }
  }
</style>

